import { ReferralResponseSchema, type ReferralResponse } from '../contracts/referral';
import type { RequestFn } from './client';

/**
 * Namespace `client.referral` — транспорт для `GET /api/referral` (Блок 11,
 * экран 2.11.4 «Реферальная программа», ADR-0094). **ТОЛЬКО транспорт.**
 *
 * **Out of scope (явно):**
 *   - Реальный эндпоинт `GET /api/referral` + генерация реферального кода/ссылки
 *     + учёт регистраций по ссылке + правило «1/мес» для бонуса — Region API /
 *     билинг-бэк (Фаза 1). 11.D — MSW-мок.
 *   - Регистрация по реферальной ссылке (онбординг должен принять `?ref=`/`/i/<code>`)
 *     — отдельная задача фундамента (бэк); этот namespace её НЕ реализует.
 *
 * `auth: true` — приватный эндпоинт, пользователь берётся из JWT (не из тела).
 * У `GET /api/referral` входного payload нет (P-006/P-007). Относительный путь
 * (P-013), типизированный клиент (P-012), Zod-валидация ответа (контракт-drift
 * ловится через PARSE_ERROR в client.ts).
 *
 * **P-009:** ответ — только счётчики (без имён/телефонов друзей); схема это
 * фиксирует — даже если бэк когда-то отдаст лишнее, default-strip срежет до сети.
 */
export interface ReferralApi {
  /**
   * GET /api/referral — персональная ссылка + счётчики рефералов.
   *
   * @returns `ReferralResponse` — `{ inviteUrl, referralsCount, paidReferralsCount, bonusAvailable }`.
   * @throws `ApiClientError` при 401 / network / 5xx / PARSE_ERROR.
   */
  get(): Promise<ReferralResponse>;
}

export function createReferralApi(request: RequestFn): ReferralApi {
  return {
    get: () =>
      request({
        method: 'GET',
        path: '/api/referral',
        responseSchema: ReferralResponseSchema,
        auth: true,
      }),
  };
}
